export async function getRandomQuote() {
    let response = await fetch("https://api.quotable.io/random");
    let quote = await response.json();
    return checkQuoteLength(quote);
}
export async function getQuote(query) {
    let response = await fetch("https://api.quotable.io/quotes/" + query);
    let quote = await response.json();
    return checkQuoteLength(quote);
}
function checkQuoteLength(quote) {
    if (quote.length <= 54) {
        quote.class = "quoteSmall";
    }
    else if (quote.length <= 88) {
        quote.class = "quoteMedium";
    }
    else if (quote.length <= 150) {
        quote.class = "quoteLarge";
    }
    else if (quote.length <= 200 || quote.length > 201) {
        quote.class = "quoteXLarge";
    }
    return quote;
}
